<template>
    <div class="grid
                m-auto
                w-full
                max-w-full leading-none"
        :class="daysAndHours? 'grid-cols-8': 'grid-cols-5'">
        <div v-if="daysAndHours" class="col-span-2">
            <p :class="copyColor"
               class="font-bold
                      text-4xl
                      desktop:text-6xl">{{ days }}</p>
            <p
                v-if="displayLabels"
                :class="copyColor"
                class="font-bold
                      text-center">
                Days
            </p>
        </div>
        <div v-if="daysAndHours" class="col-span-1">
            <p :class="copyColor"
               class="font-bold
                      text-4xl
                      desktop:text-6xl">{{ hours }}</p>
            <p
                v-if="displayLabels"
                :class="copyColor"
                class="font-bold
                      text-center">
                Hours
            </p>
        </div>
        <div v-if="daysAndHours" class="col-span-1
                    text-4xl
                    desktop:text-6xl
                    font-bold
                    text-center">
            :
        </div>
        <div :class="daysAndHours? 'col-span-1': 'col-span-2'">
            <p :class="copyColor"
               class="font-bold
                      text-4xl
                      desktop:text-6xl">
                {{ minutes }}
            </p>
            <p
                v-if="displayLabels"
                :class="copyColor"
                class="font-bold
                      text-center">
                Minutes
            </p>
        </div>
        <div class="col-span-1
                    text-4xl
                    desktop:text-6xl
                    font-bold
                    text-center">
            :
        </div>
        <div :class="daysAndHours? 'col-span-1': 'col-span-2'">
            <p :class="copyColor"
               class="font-bold
                      text-4xl
                      desktop:text-6xl">
                {{ seconds }}
            </p>
            <p
                v-if="displayLabels"
                :class="copyColor"
                class="font-bold
                      text-center">
                Seconds
            </p>
        </div>
        <div v-if="daysAndHours" class="col-span-1"></div>
    </div>
</template>

<script>
export default {
    name: "CountdownTimer",
    components: {},
    props: {
        copyColor: {
            type: String,
            default: 'text-navy-dark',
        },
        date: {
            type: [String,Number],
            default: '',
        },
        displayLabels: {
            type: Boolean,
            default: true,
        },
        daysAndHours: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        days: '0',
        hours: '00',
        minutes: '00',
        seconds: '00',
        showing: null,
        timer: null
    }),
    mounted() {
        let date = new Date(this.date).getTime()
        if (date - new Date().getTime() > 0) {
            this.timer = setInterval(function () {
                let timeTill = date - new Date().getTime()

                if (timeTill > 0) {
                    if(this.showing !== true) {
                        this.$emit('show-layer', true)
                        this.showing = true
                    }
                    this.days = Math.floor(timeTill / (1000 * 60 * 60 * 24));
                    this.hours = Math.floor((timeTill % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));


                    let minutes = Math.floor((timeTill % (1000 * 60 * 60)) / (1000 * 60));
                    this.minutes = minutes < 10? '0' + minutes: minutes

                    let seconds = Math.floor((timeTill % (1000 * 60)) / 1000);
                    this.seconds = seconds < 10? '0' + seconds: seconds
                } else {
                    this.$emit('show-layer', false)
                    this.showing = false
                    clearInterval(this.timer)
                }
            }.bind(this), 1000)
        }
    }
}
</script>
